import styled from 'styled-components';
import { media } from '../../../constants/media/media';
import { Column } from '../../base/grid';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';
import { A } from '../../base/typography';

export const FormWrapper = styled(Column)`
	width: 55%;
	padding: 10rem 10rem;

	p {
		padding: 2rem 0;
	}
	label {
		margin-top: 1rem;
	}

	button {
		width: 100%;
		margin-top: 5rem;
	}

	${media.mobileOnly`
        padding: 4rem 0;
        width: 100%;
    `}

	${media.desktopHuge`
        padding: 10rem 20rem;
    `}
`;

export const ImageWrapper = styled(Column)`
	width: 45%;

	${media.mobileOnly`display: none;`}
`;

export const Image = styled(DynamicRspImage)`
	width: 100%;
	height: 100%;
`;

export const Link = styled(A)`
	display: block;
	margin-top: 1rem;
`;
